import React from 'react';
import configs from 'configs';
import { useTranslation } from 'utils/modifiedTranslation';
import { CopyButton } from './CopyButton';
import styles from './phoneIsAlreadyUsed.module.css';

const { generalSupport: { email: supportEmail } } = configs;

const EMAIL_PLACEHOLDER = '<EMAIL_PLACEHOLDER>';

const getContent = (text) => {
  const handleSupportEmailCopy = () => {
    navigator.clipboard.writeText(supportEmail)
      .catch((ex) => {
        console.error('Failed to copy text: ', ex);
      });
  };

  const indexOfEmailPlaceholder = text.indexOf(EMAIL_PLACEHOLDER);
  if (indexOfEmailPlaceholder === -1) {
    return text;
  }

  return (
    <>
      {text.slice(0, indexOfEmailPlaceholder)}
      <span className={styles.supportEmail}>
        {supportEmail}
      </span>
      <CopyButton onClick={handleSupportEmailCopy} />
      {text.slice(indexOfEmailPlaceholder + EMAIL_PLACEHOLDER.length)}
    </>
  );
};

export const PhoneIsAlreadyUsed = () => {
  const { t } = useTranslation();
  return (
    <p className={styles.root}>
      {getContent(t('phone_is_used_popup.text'))}
    </p>
  );
};
